import React, { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { MenuContext } from "../../App";
import SearchedComponent from "../../components/SearchedComponent";
import { fetchAllResupplySettingsService } from "../../services/resupplySettingsService";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { Home } from "@mui/icons-material";

const ResupplySettings = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [addResupplySettings, setAddResupplySettings] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      fetchAllResupplySettings(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateResupplySettings",
      );
      if (createFound) {
        canAdd = true;
      }
      setAddResupplySettings(canAdd);
    } else if (role === "Admin") {
      setAddResupplySettings(true);
    }
  }, [systemActions]);

  const columns = [
    {
      field: "name",
      headerName: "Threshold",
      width: 800,
      renderHeader: () => <div className="grid-heading">{"Threshold"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <>
            <button
              className="bread-crumbs-link grid-nav-btn"
              onClick={() => {
                navigate("/addUpdate-resupply-settings", {
                  state: {
                    id: id,
                  },
                });
              }}
            >
              {name}
            </button>
          </>
        );
      },
    },
  ];

  const fetchAllResupplySettings = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllResupplySettingsService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch,
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <div className="home-container">
          <p
            className="bread-crumbs-link-container"
            style={{ fontWeight: "600" }}
          >
            <Link className="bread-crumbs-link" to="/">
              Home
            </Link>{" "}
            |{" "}
            <Link className="bread-crumbs-link" to="/resupply-settings">
              Resupply Settings
            </Link>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Link className="bread-crumbs-link home-inner-container">
            Set as Home Page
            <span>
              <Home
                sx={{
                  fontSize: "20px",
                }}
              />
            </span>
          </Link>
        </div>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Resupply Settings</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Resupply Settings"
                searchedValue={searchedValue}
              />
              {addResupplySettings ? (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-resupply-settings")}
                >
                  Add Resupply Setting
                </button>
              ) : null}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default ResupplySettings;
